<template>
  <v-container fill-height>
    <v-row class="align-center justify-center">
      <v-col
        class="text-center"
        cols="6"
        xs="1"
        lg="4"
      >
        <v-card
          class="login"
          color="#f5f5f5"
          flat
        >
          <v-col class="pa-0 ma-0">
            <img src="/img/komacut.svg" width="300px">
          </v-col>

          <v-col class="pa-0 ma-0">
            <span class="font-weight-thin caption">
              {{ $t('form.login.title') }} v.{{ appVersion }}
            </span>
          </v-col>

          <v-col class="pt-4">
            <span class="title subtitle-1">
              {{ $t('form.login.heading') }}
            </span>
          </v-col>

          <v-card-text>
            <v-icon x-large>
              mdi-clipboard-account
            </v-icon>

            <v-form @submit.prevent="loginSubmit">
              <v-text-field
                v-model="user.email"
                :label="$t('form.login.fields.user')"
                required
                autofocus
              />

              <v-text-field
                v-model="user.password"
                :label="$t('form.login.fields.password')"
                type="password"
                required
              />

              <v-btn
                type="submit"
                color="success"
                :loading="isAuthenticatePending"
              >
                <span v-if="isAuthenticated">
                  {{ $t('form.login.buttons.success') }}
                </span>
                <span v-else>
                  {{ $t('form.login.buttons.login') }}
                </span>
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { resetStores } from '../store';
import { LEVEL } from '../utils/log';

export default {
  name: 'login',

  data() {
    return {
      authenticating: false,
      user: {
        email: '',
        password: '',
      },
    };
  },

  computed: {
    ...mapState('auth', [
      'isAuthenticatePending',
    ]),

    ...mapGetters('auth', [
      'isAuthenticated',
    ]),

    ...mapGetters('app', [
      'appVersion',
    ]),
  },

  mounted() {
    resetStores();
  },

  methods: {
    ...mapActions('auth', { secureLogin: 'login' }),
    ...mapActions('app', ['pushSnack']),

    async loginSubmit() {
      try {
        localStorage.removeItem('feathers-jwt');

        await this.secureLogin({ user: this.user });

        this.pushSnack({
          snack: { message: this.$t('form.login.success.login') },
          level: LEVEL.SUCCESS,
        });

        this.$router.push('/');
      } catch (e) {
        console.error(e);
        this.pushSnack({
          snack: { message: e.code === 401 ? this.$t('form.login.error.credentials') : e.message },
          level: LEVEL.ERROR,
        });
      }
    },
  },
};
</script>

<style scoped>
.login-card {
  z-index: 5;
}
</style>
